module.exports = __webpack_public_path__ + "static/media/1_logoDMS.8558520f.jpg";